// extracted by mini-css-extract-plugin
module.exports = {"select":"Fd78Wxrd"};